<template id="backToTop">
  <div id="imagecont" :class="generalBackground">
    <div style="height: 70px;"></div>
    <b-container v-show="picvisible">
      <!-- <b-container class="backrow bv-example-row bv-example-row-flex-cols"  :style="{ background: 'url(' + backRowStyle + ')'+' center / cover no-repeat' }"> -->
      <b-container :class="backRowStyle" class="bv-example-row bv-example-row-flex-cols">
        <!-- <b-container class="backrow bv-example-row bv-example-row-flex-cols" :style="backRowStyle"> -->
        <b-row class="titlepos align-items-center" :class="textVendor">
          <b-col class="mt-5" align-self="center">
            Drive now, Pay Later !
          </b-col>
        </b-row>
      </b-container>
      <b-container class="bv-example-row">
        <b-row cols="12" class="buttonloc justify-content-md-center">
          <b-col col lg="4">
            <b-button
              block
              size="lg"
              class="buttontextsize"
              style="height: 70px; font-weight: bold;"
              :class="[isActive ? 'red' : 'blue']"
              @click="toggleClass()"
              >Enter Make / Model</b-button
            >
          </b-col>
          <b-col col lg="4">
            <b-button
              block
              size="lg"
              class="buttontextsize"
              style="height: 70px; font-weight: bold;"
              :class="[isActive ? 'blue' : 'red']"
              @click="toggleClassTwo()"
              >Enter VIN</b-button
            >
          </b-col>
        </b-row>
      </b-container>
      <b-container class="mt-4">
        <VandM :message="isActive"></VandM>
        <b-row class="justify-content-md-center align-items-center">
          <b-col cols="6">
            <hr />
          </b-col>
        </b-row>
        <b-row class="justify-content-md-center align-items-center">
          <b-col>
            <p style="color:darkgrey;">
              powered by ezfixd.com
            </p>
          </b-col>
        </b-row>
      </b-container>
    </b-container>
    <transition name="fade">
      <div v-if="visible" class="vue-back-to-top">
        <VandM :message="msg" />
      </div>
    </transition>
  </div>
</template>

<script>
import $ from 'jquery'

export default {
  name: 'Main',
  props: {
    text: {
      type: String,
      default: 'text',
    },
    visibleoffset: {
      type: [String, Number],
      default: 600,
    },
    left: {
      type: String,
      default: '0px',
    },
    bottom: {
      type: String,
      default: '0px',
    },
  },
  data() {
    return {
      msg: 'i did it',
      showCreditCard: true,
      buttontoggler: 'primary',
      opbuttontoggler: 'outline-primary',
      myToggle: false,
      isActive: false,
      visible: false,
      picvisible: true,
      textone: 'omer',
      showstar: false,
      mycolor: '0E78E1',
      parameters: '',
      image:
        'http://1.bp.blogspot.com/-8PfnHfgrH4I/TylX2v8pTMI/AAAAAAAAJJ4/TICBoSEI57o/s1600/search_by_image_image.png',
      appData: {
        backgroundObject: 'backwidg.png',
        backgroundObjectGrizzly: 'grizzly.png',
      },
    }
  },
  computed: {
    backRowStyle() {
      console.log(this.appData.backgroundObject)
      console.log(this.image)
      console.log('running backRowStyle and ID is' + this.$route.query.vendor)

      if (this.$route.query.vendor === '123') {
        return 'backrow'
      } else if (this.$route.query.vendor === '619d60ac3ddfde0bc5120f14') {
        return 'backrowGrizzly'
      } else {
        return 'backrow'
      }
    },
    generalBackground() {
      if (this.$route.query.vendor === '123') {
        return 'generalBackground'
      } else if (this.$route.query.vendor === '619d60ac3ddfde0bc5120f14') {
        return 'grizzlyBackground'
      } else {
        return 'generalBackground'
      }
    },
    textVendor() {
      if (this.$route.query.vendor === '123') {
        return 'generalText'
      } else if (this.$route.query.vendor === '619d60ac3ddfde0bc5120f14') {
        return 'grizzlyText'
      } else {
        return 'generalText'
      }
    },
  },
  beforeMount() {
    console.log('before mount')
    console.log('this is vendor ID' + this.$route.query.vendor)
    const urlParams = new URLSearchParams(window.location.search)

    const vendor = urlParams.get('vendor')
    const productDescription = urlParams.get('productDescription')
    const price = urlParams.get('price')

    console.log('Vendor:', vendor)
    console.log('Product Description:', productDescription)
    console.log('Price:', price)

    this.$store.state.userData.selectedVendor = vendor
    this.$store.state.userData.selectedProduct = productDescription
    this.$store.state.userData.productPrice = price
    this.$store.state.userData.repairOfferAmount = price

    if (typeof this.$store.state.userData.selectedVendor === 'undefined') {
      this.$store.state.userData.selectedVendor = '5e595abe5f786369a72bfd3f'
    } else {
      console.log('this is vendor' + this.$store.state.userData.selectedVendor)
    }
  },
  methods: {
    toggleClass() {
      console.log(this.$store.state.userData.step)
      if (this.$store.state.userData.step > 1) {
        this.$store.state.userData.step = 0
        location.reload()
      } else {
        if ((this.isActive = true)) this.isActive = !this.isActive
      }
    },
    toggleClassTwo() {
      console.log(this.$store.state.userData.step)
      if (this.$store.state.userData.step > 1) {
        this.$store.state.userData.step = 0
        location.reload()
      } else {
        if ((this.isActive = false)) console.log(this.isActive)
        this.isActive = !this.isActive
      }
    },
    onpicOne() {
      if ('parentIFrame' in window) window.parentIFrame.size(560)
      return false
    },
    onpicTwo() {
      return [(this.visible = true), (this.picvisible = false)]
    },
  },
  template: '#backToTop',
}
</script>
<style scoped media="screen">
@import url('https://fonts.googleapis.com/css2?family=Archivo+Black&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Inter+Tight:ital,wght@1,900&display=swap');

hr {
  display: block;
  height: 1px;
  border: 0;
  border-top: 1px solid #ccc;
  margin: 1em 0;
  padding: 0;
}

.align-items-center {
  display: flex;
  align-items: center;
  justify-content: center;
}

@import url('https://fonts.googleapis.com/css2?family=Open+Sans:wght@600&display=swap');

@media screen and (min-width: 1501px) {
  .titlepos {
    font-size: 2vw;
  }
}

@media screen and (min-width: 1001px) and (max-width: 1500px) {
  .titlepos {
    font-size: 3.5vw;
  }
}

@media screen and (min-width: 401px) and (max-width: 1000px) {
  .titlepos {
    font-size: 5vw;
  }
}

@media screen and (max-width: 400px) {
  .titlepos {
    font-size: 7vw;
  }
}

@media screen and (min-width: 1001px) and (max-width: 1500px) {
  .buttontextsize {
    font-size: 2vw;
  }
}

@media screen and (min-width: 701px) and (max-width: 1000px) {
  .buttontextsize {
    font-size: 2.5vw;
  }
}

@media screen and (min-width: 401px) and (max-width: 700px) {
  .buttontextsize {
    font-size: 3vw;
  }
}

@media screen and (max-width: 400px) {
  .buttontextsize {
    font-size: 4vw;
  }
}

.titlepos {
  position: absolute;
  margin-left: 0px;
  margin-right: 0px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  min-width: 250px;
  color: black;
  font-family: 'Inter Tight', sans-serif;
  color: #3b3b3b;
}
.red {
  border-color: #109de7;
  background: white;
  color: black;
}

.blue {
  background-color: #109de7;
  border-color: #109de7;
}

.am-active {
  background-color: rgb(21, 79, 202);
  color: white;
}

.am-not-active {
  background-color: white;
}

.alignit {
  text-align: center;
  border: 3px solid green;
}

.buttonvin {
  background-color: white;
}

.buttonmake {
  background-color: #109de7;
}

.backrow {
  background: url('../assets/images/backwidg.png') center / cover no-repeat;
  width: 100%;
  height: 300px;
  object-fit: cover;
  position: relative;
}

.backrowGrizzly {
  background: url('../assets/images/grizzly.png') center / cover no-repeat;
  width: 100%;
  height: 300px;
  object-fit: cover;
  position: relative;
}

.testdiv {
  background: url('../assets/images/backwidg.png') center / cover no-repeat;
}

.vue-back-to-top {
  z-index: 1000;
  cursor: pointer;
  position: fixed;
}

.buttonloc {
  margin-top: -20px;
}

.generalBackground {
  background-color: white;
}

.grizzlyBackground {
  background: url('../assets/images/backgroundCarParts.png');
  background-repeat: repeat;
}

.generalText {
  color: black;
}

.grizzlyText {
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/main.vue